import { render, staticRenderFns } from "./AmbientLights.vue?vue&type=template&id=1da51289&scoped=true&"
import script from "./AmbientLights.vue?vue&type=script&lang=js&"
export * from "./AmbientLights.vue?vue&type=script&lang=js&"
import style0 from "./AmbientLights.vue?vue&type=style&index=0&id=1da51289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da51289",
  null
  
)

export default component.exports